
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, axiosInstanceB2B } from '@share/utils';
import { getHeaders } from '@share/utils';

export interface IAshevillePlayState {
  deals: (any | null)[];
  loadings: boolean[];
  errors: (string | null)[];
}

const initialState: IAshevillePlayState = {
  deals: [],
  loadings: [],
  errors: [],
};

const ashevillePlaySlice = createSlice({
  name: 'ashevillePlay',
  initialState,
  reducers: {
    setLoadingsAshevillePlay: (state: IAshevillePlayState, { payload }: PayloadAction<boolean[]>) => {
      state.loadings = payload;
    },
    setErrorsAshevillePlay: (state: IAshevillePlayState, { payload }: PayloadAction<string[]>) => {
      state.errors = payload;
    },
    setDealsAshevillePlay: (state: IAshevillePlayState, { payload }: PayloadAction<any[]>) => {
      state.deals = payload;
    },

    setClearLoadingAshevillePlayByIndex: (state: IAshevillePlayState, { payload }: PayloadAction<number>) => {
      state.loadings[payload] = false;
    },
    setErrorAshevillePlayByIndex: (state: IAshevillePlayState, { payload }: PayloadAction<{ index: number, error: string }>) => {
      state.errors[payload.index] = payload.error;
    },
    setDealsAshevillePlayByIndex: (state: IAshevillePlayState, { payload }: PayloadAction<{ index: number, deal: any }>) => {
      state.deals[payload.index] = payload.deal;
    },
  },
});

export const {
  setLoadingsAshevillePlay,
  setErrorsAshevillePlay,
  setClearLoadingAshevillePlayByIndex,
  setErrorAshevillePlayByIndex,
  setDealsAshevillePlay,
  setDealsAshevillePlayByIndex
} = ashevillePlaySlice.actions;

export const ashevillePlayReducer = ashevillePlaySlice.reducer;

export const getAshevillePlayDeals = (): AppThunk => {
  return async (dispatch, getState) => {
    const { loginStore } = getState();
    const { account } = loginStore;

    const bestDeals = account?.ashevillePlayBestDeals || [];

    try {
      await dispatch(setLoadingsAshevillePlay(bestDeals.map(() => true)));
      await dispatch(setErrorsAshevillePlay(bestDeals.map(() => null)));
      await dispatch(setDealsAshevillePlay(bestDeals.map(() => null)));

      bestDeals.forEach(async (deal: any, index: number) => {
        try {
          const res = await axiosInstanceB2B.get(`/contents/property/${deal}`);
  
          await dispatch(setClearLoadingAshevillePlayByIndex(index));
  
          await dispatch(setDealsAshevillePlayByIndex({ index, deal: res.data }));
        } catch (error: any) {
          await dispatch(setClearLoadingAshevillePlayByIndex(index));
          await dispatch(setErrorAshevillePlayByIndex({ index, error: error.toString() }));
        }
      });

    } catch (error: any) {
      console.error(error);
      await dispatch(setLoadingsAshevillePlay(bestDeals.map(() => false)));
      await dispatch(setErrorsAshevillePlay(bestDeals.map(() => null)));
    }
  };
};
